import { View, StyleSheet } from "react-native";
import React from "react";
import ProfileAvatar from "components/ProfileAvatar";
import { AccountMemberDetails } from "features/types";
import { Text } from "@ui-kitten/components";
import { initial } from "utils/userUtils";

interface UserInfoProps {
  userImageURL: string;
  currentMember: AccountMemberDetails;
}
const UserInfo: React.FC<UserInfoProps> = ({ userImageURL, currentMember }) => {
  if (!currentMember) return null;

  const {
    user: { imageIdentifier, firstName, lastName, email },
  } = currentMember;

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <View>
        <ProfileAvatar
          source={{ uri: userImageURL }}
          hasImageIdentifier={imageIdentifier !== null}
          size={60}
          initial={initial(currentMember.user)}
        />
      </View>
      <View>
        <Text
          style={styles.personalInfoStyle}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {firstName as string} {lastName as string}
        </Text>
        <Text
          style={styles.personalInfoStyle}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {email}
        </Text>
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  personalInfoStyle: {
    fontWeight: "600",
    padding: 5,
    maxWidth: 280,
  },
});
export default UserInfo;
